import type { HTMLAttributes, ReactElement } from 'react';

/** @internal */
export const AlignCenterIcon = (props: HTMLAttributes<HTMLOrSVGElement>): ReactElement => (
  <svg
    fill='none'
    height='23'
    viewBox='0 0 30 23'
    width='30'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M29.5 4.55V18.45C29.5 20.55 27.8 22.25 25.7 22.25H23.7V20.65H25.7C26.9 20.65 27.9 19.65 27.9 18.45V4.55C27.9 3.35 26.9 2.35 25.7 2.35H3.8C2.6 2.35 1.6 3.35 1.6 4.55V18.45C1.6 19.65 2.6 20.65 3.8 20.65H5.7V22.25H3.8C1.7 22.25 0 20.55 0 18.45V4.55C0.1 2.45 1.8 0.75 3.9 0.75H25.8C27.8 0.75 29.5 2.45 29.5 4.55ZM14.7 13.25C13.1 13.25 11.8 11.95 11.8 10.35V7.65C11.8 6.05 13.1 4.75 14.7 4.75C16.3 4.75 17.6 6.05 17.6 7.65V10.35C17.6 11.95 16.3 13.25 14.7 13.25ZM14.6 11.75C15.4 11.75 16 11.15 16 10.35V7.65C16 6.85 15.4 6.25 14.6 6.25C13.8 6.25 13.2 6.85 13.2 7.65V10.35C13.2 11.15 13.9 11.75 14.6 11.75ZM21.2 18.75V20.75V22.25H19.7H9.7H8.2V20.75V18.75C8.2 17.05 9.5 15.75 11.2 15.75H18.2C19.9 15.75 21.2 17.05 21.2 18.75ZM19.8 18.75C19.8 17.95 19.1 17.25 18.3 17.25H11.3C10.5 17.25 9.8 17.95 9.8 18.75V20.75H19.8V18.75Z'
      fill={props.color ?? '#A9B3C6'}
    />
  </svg>
);

/** @internal */
export const AlignLeftIcon = (props: HTMLAttributes<HTMLOrSVGElement>): ReactElement => (
  <svg
    fill='none'
    height='23'
    viewBox='0 0 30 23'
    width='30'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7.8 7.65V10.35C7.8 11.95 9.1 13.25 10.7 13.25C12.3 13.25 13.6 11.95 13.6 10.35V7.65C13.6 6.05 12.3 4.75 10.7 4.75C9.1 4.75 7.8 6.05 7.8 7.65ZM12.1 7.65V10.35C12.1 11.15 11.5 11.75 10.7 11.75C9.9 11.75 9.3 11.15 9.3 10.35V7.65C9.3 6.85 9.9 6.25 10.7 6.25C11.4 6.25 12.1 6.85 12.1 7.65ZM25.7 0.75H3.8C1.7 0.75 0 2.45 0 4.55V18.45C0 20.55 1.7 22.25 3.8 22.25H4.3H5.8H15.8H17.3V20.65V18.65C17.3 16.95 16 15.65 14.3 15.65H7.3C5.6 15.65 4.3 16.95 4.3 18.65V20.65H3.8C2.6 20.65 1.6 19.65 1.6 18.45V4.55C1.6 3.35 2.6 2.35 3.8 2.35H25.7C26.9 2.35 27.9 3.35 27.9 4.55V18.45C27.9 19.65 26.9 20.65 25.7 20.65H19.8V22.25H25.7C27.8 22.25 29.5 20.55 29.5 18.45V4.55C29.4 2.45 27.7 0.75 25.7 0.75ZM5.8 18.65C5.8 17.85 6.5 17.15 7.3 17.15H14.3C15.1 17.15 15.8 17.85 15.8 18.65V20.65H5.8V18.65Z'
      fill={props.color ?? '#A9B3C6'}
    />
  </svg>
);

/** @internal */
export const AlignRightIcon = (props: HTMLAttributes<HTMLOrSVGElement>): ReactElement => (
  <svg
    fill='none'
    height='23'
    viewBox='0 0 30 23'
    width='30'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.8 20.65H3.8C2.6 20.65 1.6 19.65 1.6 18.45V4.55C1.6 3.35 2.6 2.35 3.8 2.35H25.7C26.9 2.35 27.9 3.35 27.9 4.55V18.55C27.9 19.75 26.9 20.75 25.7 20.75H25.3V18.75C25.3 17.05 24 15.75 22.3 15.75H15.3C13.6 15.75 12.3 17.05 12.3 18.75V20.75V22.25H13.8H23.8H25.3H25.7C27.8 22.25 29.5 20.55 29.5 18.45V4.45C29.4 2.45 27.7 0.75 25.7 0.75H3.8C1.7 0.75 0 2.45 0 4.55V18.45C0 20.55 1.7 22.25 3.8 22.25H9.8V20.65ZM23.8 20.75H13.8V18.75C13.8 17.95 14.5 17.25 15.3 17.25H22.3C23.1 17.25 23.8 17.95 23.8 18.75V20.75ZM21.8 10.35V7.65C21.8 6.05 20.5 4.75 18.9 4.75C17.3 4.75 16 6.05 16 7.65V10.35C16 11.95 17.3 13.25 18.9 13.25C20.4 13.25 21.8 11.95 21.8 10.35ZM17.4 10.35V7.65C17.4 6.85 18 6.25 18.8 6.25C19.6 6.25 20.2 6.85 20.2 7.65V10.35C20.2 11.15 19.6 11.75 18.8 11.75C18.1 11.75 17.4 11.15 17.4 10.35Z'
      fill={props.color ?? '#A9B3C6'}
    />
  </svg>
);

/** @internal */
export const FrameMid = (props: HTMLAttributes<HTMLOrSVGElement>): ReactElement => (
  <svg
    fill='none'
    height='23'
    viewBox='0 0 30 23'
    width='30'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17.5 14.55H11.9C10.7 14.55 9.7 15.55 9.7 16.75V20.75V22.25H11.2H18.3H19.8V20.75V16.75C19.8 15.55 18.7 14.55 17.5 14.55ZM18.2 20.75H11.1V16.75C11.1 16.35 11.4 16.05 11.8 16.05H17.4C17.8 16.05 18.1 16.35 18.1 16.75V20.75H18.2ZM17.5 9.95V7.55C17.5 6.05 16.3 4.75 14.7 4.75C13.1 4.75 12 5.95 12 7.55V10.05C12 11.55 13.2 12.85 14.8 12.85C16.4 12.85 17.5 11.45 17.5 9.95ZM13.5 9.95V7.55C13.5 6.85 14.1 6.35 14.7 6.35C15.3 6.35 16 6.85 16 7.55V10.05C16 10.75 15.4 11.25 14.8 11.25C14.2 11.25 13.5 10.65 13.5 9.95ZM29.5 4.55V18.55C29.5 20.65 27.8 22.35 25.7 22.35H22.7H22V20.75H22.8H25.8C27 20.75 28 19.75 28 18.55V4.55C28 3.35 27 2.35 25.8 2.35H3.8C2.6 2.35 1.6 3.35 1.6 4.55V18.55C1.6 19.75 2.6 20.75 3.8 20.75H6.8H7.6V22.25H6.8H3.8C1.7 22.25 0 20.55 0 18.45V4.45C0 2.45 1.7 0.75 3.8 0.75H25.8C27.8 0.75 29.5 2.45 29.5 4.55Z'
      fill={props.color ?? '#A9B3C6'}
    />
  </svg>
);

/** @internal */
export const FrameTight = (props: HTMLAttributes<HTMLOrSVGElement>): ReactElement => (
  <svg
    fill='none'
    height='23'
    viewBox='0 0 30 23'
    width='30'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19.6 17.55H9.9C7.9 17.55 6.3 18.95 5.9 20.75C5.8 21.05 5.8 21.35 5.8 21.65V22.25H7.3H22.2H23.7V21.65C23.7 21.35 23.7 21.05 23.6 20.75C23.1 18.95 21.5 17.55 19.6 17.55ZM7.5 20.75C7.9 19.75 8.8 19.05 9.9 19.05H19.5C20.6 19.05 21.6 19.75 21.9 20.75H7.5ZM18.4 12.15V8.45C18.4 6.35 16.7 4.75 14.7 4.75C12.7 4.75 11 6.45 11 8.45V12.15C11 14.25 12.7 15.85 14.7 15.85C16.7 15.85 18.4 14.15 18.4 12.15ZM12.4 12.15V8.45C12.4 7.25 13.4 6.25 14.6 6.25C15.8 6.25 16.8 7.25 16.8 8.45V12.15C16.8 13.35 15.8 14.35 14.6 14.35C13.4 14.35 12.4 13.35 12.4 12.15ZM29.5 4.55V18.55C29.5 20.65 27.8 22.35 25.7 22.35V20.75C26.9 20.75 27.9 19.75 27.9 18.55V4.55C27.9 3.35 26.9 2.35 25.7 2.35H3.7C2.5 2.35 1.5 3.35 1.5 4.55V18.55C1.5 19.75 2.5 20.75 3.7 20.75V22.25C1.6 22.25 -0.0999985 20.55 -0.0999985 18.45V4.45C1.52737e-06 2.45 1.7 0.75 3.8 0.75H25.8C27.8 0.75 29.5 2.45 29.5 4.55Z'
      fill={props.color ?? '#A9B3C6'}
    />
  </svg>
);

/** @internal */
export const FrameWide = (props: HTMLAttributes<HTMLOrSVGElement>): ReactElement => (
  <svg
    fill='none'
    height='23'
    viewBox='0 0 30 23'
    width='30'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16.3 10.425H13.1C12 10.425 11.2 11.325 11.2 12.325V14.825C11.2 15.425 11.5 16.025 12 16.425V20.225C12 21.225 12.8 22.125 13.9 22.125H15.5C16.6 22.125 17.4 21.225 17.4 20.225V16.425C17.9 16.025 18.2 15.425 18.2 14.825V12.325C18.2 11.325 17.5 10.425 16.3 10.425ZM16.8 14.825C16.8 15.025 16.6 15.225 16.4 15.225H16V16.725V20.225C16 20.425 15.8 20.625 15.6 20.625H14C13.8 20.625 13.6 20.425 13.6 20.225V16.725V15.225H13.2C13 15.225 12.8 15.025 12.8 14.825V12.325C12.8 12.125 13 11.925 13.2 11.925H16.4C16.6 11.925 16.8 12.125 16.8 12.325V14.825ZM29.5 4.425V18.425C29.5 20.525 27.8 22.225 25.7 22.225H20.7H20V20.625H20.8H25.8C27 20.625 28 19.625 28 18.425V4.425C28 3.225 27 2.225 25.8 2.225H3.8C2.6 2.225 1.6 3.225 1.6 4.425V18.425C1.6 19.625 2.6 20.625 3.8 20.625H8.8H9.6V22.125H8.8H3.8C1.7 22.125 0 20.425 0 18.325V4.325C0 2.325 1.7 0.625 3.8 0.625H25.8C27.8 0.625 29.5 2.325 29.5 4.425ZM17.2 6.425C17.2 5.025 16.1 3.925 14.7 3.925C13.3 3.925 12.2 5.025 12.2 6.425C12.2 7.825 13.3 8.925 14.7 8.925C16.1 8.925 17.2 7.725 17.2 6.425ZM13.8 6.425C13.8 5.825 14.2 5.425 14.8 5.425C15.4 5.425 15.8 5.825 15.8 6.425C15.8 7.025 15.4 7.425 14.8 7.425C14.2 7.425 13.8 6.925 13.8 6.425Z'
      fill={props.color ?? '#A9B3C6'}
    />
  </svg>
);
